import { GuardedDeletionService, ThirdPartyPropertyService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ThirdPartyPropertyCreateDto,
  ThirdPartyPropertyDto,
  ThirdPartyPropertyExcelDownloadDto,
  ThirdPartyPropertyUpdateDto,
} from '../proxy/planning/dtos/third-party-property';
import { THIRDPARTYPROPERTY_CONFIG, THIRDPARTYPROPERTY_FIELDS } from './third-party-property.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-third-party-property',
  imports: [
    CommonModule,
    CrudPage,
    GenericForm,
    ZnHierarchicalViewComponent
  ],
  providers: [ListService, ThirdPartyPropertyService, ConfirmationService],
  templateUrl: './third-party-property.html',
  styleUrl: './third-party-property.scss',
})
export class ThirdPartyProperty extends BaseHierarchicalCrudComponent<
  ThirdPartyPropertyDto,
  ThirdPartyPropertyCreateDto,
  ThirdPartyPropertyUpdateDto,
  ThirdPartyPropertyExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(ThirdPartyPropertyService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('ThirdPartyProperty', ids),
  };
  config = THIRDPARTYPROPERTY_CONFIG;
  fields = THIRDPARTYPROPERTY_FIELDS;

  protected prepareUpdateDto(data: any, selected: ThirdPartyPropertyDto): ThirdPartyPropertyUpdateDto {
    return {
      name: data.name,
      mgsCode: data.mgsCode,
      ownerVendorId: data.ownerVendorId,
      exporterVendorId: data.exporterVendorId,
      forestryManagementId: data.forestryManagementId,
      treeVolume: data.treeVolume,
      isFscCertified: data.isFscCertified,
      isPefcCertified: data.isPefcCertified,
      locationId: data.locationId,
      zoneId: data.zoneId,
      regionId: data.regionId,
      departmentId: data.departmentId,
      thirdPartyPropertyCategoryId: data.thirdPartyPropertyCategoryId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ThirdPartyProperty';
  }
}
